import { IConfig } from 'src/interfaces';
import http from './http';

class ConfigService {
  static patchConfig(data: Partial<IConfig>) {
    return http.patch('/configs', data);
  }

  static getConfig(token: string) {
    return http.get('/configs', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
export default ConfigService;
